import { Disclosure } from "@headlessui/react";
import { BarsArrowUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import RefreshButton from "components/RefreshButton";
import SearchButton from "components/SearchButton";
import SelectHookFormMulti from "components/SelectHookFormMulti";
import { hierarchyFilteredData } from "./atoms/atoms";
import { useRecoilState } from "recoil";
import { useGetHierarchyTypes } from "./hooks/useGetHierarchyTypes";

const TableFilter = ({
  filterHierchies,
  setFilteredData,
  filter,
  hierarchyData,
  setFilterStatus,
}) => {
  const [filterInputData, setFilterInputData] = useRecoilState(
    hierarchyFilteredData
  );

  //#region Hierarchy Opts
  const hierarchyNameOpts = Array.from(
    new Map(
      hierarchyData
        ?.filter((x) => x.hierarchyName !== null)
        .map((x) => [
          x.hierarchyName,
          { label: x.hierarchyName, value: x.hierarchyName },
        ])
    ).values()
  );

  const { data: hierarchyTypes, isLoading: isHierarchyTypeLoading } =
    useGetHierarchyTypes();

  const hierarchyTypeOpts = hierarchyTypes
    ?.filter((x) => x.isActive === true)
    ?.map((x) => {
      return {
        label: x.hierarchyTypeName,
        value: x.hierarchyTypeName,
      };
    });
  //#endregion

  const refreshOfficeTable = () => {
    setFilterStatus(false);
    setFilteredData([]);
    setFilterInputData({
      ...filterInputData,
      hierarchyName: "",
      hierarchyId: "",
      hierarchyTypeId: "",
      hierarchyTypeName: "",
    });
  };

  return (
    <div className="pt-2 px-4 space-y-2 ">
      <div className="pt-2">
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full">
        <div className="mb-3">
          <Disclosure defaultOpen={filter}>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span>SPLC Hierarchy Details</span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="bg-gray-100  p-3 sm:px-2 md:px-3">
                    <div className="text-xs text-secondary italic font-normal pb-4">
                      <b> Note:</b> All fields are multiple selection.
                    </div>
                    <div className="flex flex-col text-xs gap-x-4 gap-y-2">
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Hierarchy Name
                        </label>
                        <SelectHookFormMulti
                          options={hierarchyNameOpts}
                          value={filterInputData?.hierarchyName}
                          onChange={(e) => {
                            setFilterInputData({
                              ...filterInputData,
                              hierarchyId: e?.map((x) => x.value),
                              hierarchyName: e,
                            });
                          }}
                          // isLoading={isLoading}
                          secondDiv="items-center"
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Hierarchy Type
                        </label>
                        <SelectHookFormMulti
                          options={hierarchyTypeOpts}
                          value={filterInputData?.hierarchyTypeName}
                          onChange={(e) => {
                            setFilterInputData({
                              ...filterInputData,
                              hierarchyTypeId: e?.map((x) => x.value),
                              hierarchyTypeName: e,
                            });
                          }}
                          isLoading={isHierarchyTypeLoading}
                          secondDiv="items-center"
                        />
                      </div>
                      <div className="flex justify-center items-end gap-x-2 mb-12  lg:ml-4 md:ml-1 rounded-md mt-5">
                        <SearchButton
                          buttonValue="Search"
                          onClick={() => {
                            filterHierchies();
                          }}
                        />
                        <RefreshButton
                          onClick={() => {
                            refreshOfficeTable();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>
    </div>
  );
};

export default TableFilter;
